import { render, staticRenderFns } from "./TemplatesMeta.vue?vue&type=template&id=6c11ee88"
import script from "./TemplatesMeta.vue?vue&type=script&lang=js"
export * from "./TemplatesMeta.vue?vue&type=script&lang=js"
import style0 from "./TemplatesMeta.vue?vue&type=style&index=0&id=6c11ee88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports